import { SET_ATTRIBUTES } from "../constants/actionTypes";

export const setAttributes = (attributes) => ({
  type: SET_ATTRIBUTES,
  attributes,
});
